import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { errorToastOptions, successToastOptions } from 'lib/utils/toast.utils'
import { IApiError } from 'services/Shared/shared.models'
import { IDeleteInvoiceDraftRequest } from 'services/Invoices/invoices.models'
import { deleteInvoiceDraft } from 'services/Invoices/invoices.services'

const useDeleteInvoiceDraft = (
  onSuccess: () => void
): UseMutationResult<void, IApiError, IDeleteInvoiceDraftRequest> => {
  const mutation = useMutation<void, IApiError, IDeleteInvoiceDraftRequest>(
    variables => deleteInvoiceDraft(variables),
    {
      onSuccess: () => {
        toast.success('El borrador ha sido eliminado', successToastOptions)
        onSuccess()
      },
      onError: () => {
        toast.error(
          'No fue posible eliminar el borrador. Por favor intenta de nuevo más tarde',
          errorToastOptions
        )
      },
    }
  )

  return mutation
}

export default useDeleteInvoiceDraft
